'use strict';

var React = require('react');

var SvgLocationFilledMajor = function SvgLocationFilledMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.194 16c1.524-1.373 3.806-4.484 3.806-8.106 0-2.703-2.239-4.894-5-4.894s-5 2.191-5 4.894c0 3.622 2.282 6.733 3.806 8.106h-3.056a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-3.056Zm.806-8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  }));
};
SvgLocationFilledMajor.displayName = "LocationFilledMajor";

exports.SvgLocationFilledMajor = SvgLocationFilledMajor;
